import React, { memo } from "react";
import Layout from "../components/Layout";
import HeroSection from "../components/HeroSection/HeroSection";
import ProductGrid from "../components/ProductGrid/ProductGrid";
import { allCatalogProducts } from "../data/allProducts";
import Code190Page from "../pages/Code190";
import { Link } from "react-router-dom";
import "@google/model-viewer";

// NEW
import TextFeatureSlider from "../components/Slider/slider";

// Фильтры каталога на главной — только линейки
const CATALOG_FILTERS = ["all", "code46", "code23", "code55"];

const features = [
  "Технология  True-Color Holography  позволяет экрану сохранять неоновую яркость даже под прямыми лучами солнца",
  "Жидкость CODE - результат работы лучшей лаборатории Европы. Благодаря технологии Flavor Lock Matrix вкус CODE остается насыщенным до самой последней затяжки",
  "Технология AIRFLOW CONTROL PRO позволяет вам выбрать именно тот поток воздуха, который вы хотите. CODE не приемлет никаких ограничений в вопросе вашего удовольствия",
  "Металический корпус устройства выполнен  в цвете Imperial Purple, разработанным международным институтом цвета Pantone",
  "Керамическое напыление защищает CODE от любых повреждений. Мы красим каждый девайс вручную, используя самые качественные краски европейского производства",
];

const HomePage = memo(() => {
  return (
    <Layout>
      <div className="">
        <HeroSection />

        <div className="py-16">
          {/* 3D + Slider Block */}
          <div className="text-white px-6 sm:px-12 py-12 sm:py-20">
            <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
              {/* Text slider */}
              <div className="w-full lg:w-1/2">
                <TextFeatureSlider items={features} />
              </div>
              {/* 3D model */}
              <div className="w-full lg:w-1/2 flex justify-center">
                <model-viewer
                  src={process.env.PUBLIC_URL + "/models/model.glb"}
                  alt="3D catalog"
                  style={{ height: "520px", width: "100%" }}
                  auto-rotate
                  camera-controls
                  ar
                  environment-image="neutral"
                  tone-mapping="commerce"
                  exposure="1"
                  shadow-intensity="1"
                ></model-viewer>
              </div>
            </div>
          </div>

          {/* ProductGrid */}
          <div className="max-w-8xl mx-auto px-6 lg:px-12 py-8">
            <ProductGrid
              products={allCatalogProducts}
              showFilters
              filterKeys={CATALOG_FILTERS}
              shuffle
              pageSize={12}
            />
            <Code190Page isHomepage={true}/>
          </div>

          {/* Bottom headline */}
          <div
            className="max-w-7xl mx-auto px-4 sm:px-8 md:px-12 py-12 text-center animate-fade-in"
            style={{ animationDelay: "0.5s" }}
          >
            {/* <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mt-16 text-white animate-slide-up">
              Легче воздуха, ярче вкуса
            </h1> */}
          </div>
        </div>
      </div>
    </Layout>
  );
});

export default HomePage;
